import { isAndroid, isIOS, isMacOs, isWindows } from 'react-device-detect';
import { Button, Col, Image, Row } from 'antd';

import classes from './index.module.less';

const KomunitasSectDownloadContainer = () => {
	const OS = isAndroid
		? 'https://play.google.com/store/apps/details?id=crm.iluvubaby&hl=ms&gl=ID'
		: isWindows
			? 'https://play.google.com/store/apps/details?id=crm.iluvubaby&hl=ms&gl=ID'
			: isMacOs
				? 'https://apps.apple.com/id/app/hallobumil/id1507726157'
				: isIOS
					? 'https://apps.apple.com/id/app/hallobumil/id1507726157'
					: 'https://play.google.com/store/apps/details?id=crm.iluvubaby&hl=ms&gl=ID';

	return (
		<div className={classes.pagehero}>
			<div className="container" style={{ padding: '25px' }}>
				<div className={classes.wrapper}>
					<Row
						gutter={[24, 24]}
						align="middle"
						justify="space-between"
					>
						<Col
							xs={{ span: 24, order: 1 }}
							md={{ span: 12, order: 1 }}
						>
							<div className={classes.imageWrapper}>
								<Image
									src="/images/komunitas/newfooter.svg"
									alt="image-section-3"
									preview={false}
								/>
							</div>
						</Col>

						<Col
							xs={{ span: 24, order: 2 }}
							md={{ span: 12, order: 2 }}
						>
							<div>
								<h2 className={classes.title}>
									Siap bergabung bersama <br />
									<span className={classes.netralcolor}>komunitas mama HalloBumil?</span>
								</h2>

								<p className={classes.paragraph}>
									Mulai diskusi, tanya pengalaman Mama lain, dan dapatkan
									dukungan yang kamu butuhkan kapan saja, di mana saja
								</p>

								<Button
									className={classes.button}
									onClick={() => window.open(OS)}
								>
									<span style={{ padding: '0px 24px'}}>Gabung Sekarang!</span>
								</Button>

								<div className={classes.subText}>
									Gratis - Sudah diunduh 500.000+ mama
								</div>
							</div>
						</Col>
					</Row>
				</div>
			</div>
		</div>
	);
};

export default KomunitasSectDownloadContainer;
